import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileCTABar from "@/components/MobileCTABar";
import ExitIntentModal from "@/components/ExitIntentModal";
import { X } from "lucide-react";

export default function Layout({ children }) {
  const [cookieOk, setCookieOk] = useState(true);
  useEffect(() => setCookieOk(!!localStorage.getItem("kore_cookie_ok")), []);
  const accept = () => { localStorage.setItem("kore_cookie_ok", "1"); setCookieOk(true); };

  return (
    <div className="min-h-screen bg-kore-warm text-kore-ink">
      <Navbar />
      <main className="pt-20 pb-24 md:pb-0">{children}</main>
      <Footer />
      <MobileCTABar />
      <ExitIntentModal />
      {!cookieOk && (
        <div data-testid="cookie-banner" className="fixed bottom-24 md:bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 bg-kore-forest text-kore-warm rounded-2xl shadow-lift p-5 flex items-start gap-3">
          <p className="text-xs leading-relaxed flex-1">We use a small number of cookies to keep the site working. Nothing invasive.</p>
          <button onClick={accept} data-testid="cookie-accept" className="text-xs bg-kore-gold text-kore-forest px-4 py-2 rounded-full">Okay</button>
          <button onClick={accept} className="text-kore-warm/60"><X size={14} /></button>
        </div>
      )}
    </div>
  );
}
